import {
  GET_EMP_HIS_LIST_REQUEST, GET_EMP_HIS_LIST_SUCCESS, GET_EMP_HIS_LIST_FAIL
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Job Action",
  result: [],
  msg: "",
  error: "",
};

const EmploymentHistoryListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EMP_HIS_LIST_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case GET_EMP_HIS_LIST_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case GET_EMP_HIS_LIST_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default EmploymentHistoryListReducer;
